module.exports = __webpack_public_path__ + "img/AgileCRM.82084547.svg";